module.exports = __webpack_public_path__ + "static/media/vote-btn-hover.a94f9c69.png";